import {
    COMMON_FLAGS,
    FEATURE_FLAGS,
    useAccountConfig,
    useCommonConfig,
} from 'modules/taboola-common-frontend-modules/account-configurations';
import { usePermissions } from '../../../../../../taboola-common-frontend-modules/authentication';

export const useSimulatorPermission = ({ bidStrategy }) => {
    const {
        [FEATURE_FLAGS.CAMPAIGN_SIMULATOR_ENABLED]: isSimulatorConfigEnabled,
        [FEATURE_FLAGS.CAMPAIGN_SIMULATOR_CHECK_PERMISSION_ENABLED]: isSimulatorPermissionCheckEnabled,
    } = useAccountConfig([
        FEATURE_FLAGS.CAMPAIGN_SIMULATOR_ENABLED,
        FEATURE_FLAGS.CAMPAIGN_SIMULATOR_CHECK_PERMISSION_ENABLED,
    ]);
    const { [COMMON_FLAGS.CAMPAIGN_SIMULATOR_ENABLED_BIDDING_STRATEGIES]: enabledBiddingStrategies } = useCommonConfig([
        COMMON_FLAGS.CAMPAIGN_SIMULATOR_ENABLED_BIDDING_STRATEGIES,
    ]);

    const isSimulatorPermitted = usePermissions('CAMPAIGN_SIMULATOR_VIEW');
    const isSimulatorEnabledInConfig =
        isSimulatorConfigEnabled === 'true' && (isSimulatorPermissionCheckEnabled === 'false' || isSimulatorPermitted);
    const isSimulatorEnabledForBiddingStrategy = enabledBiddingStrategies.includes(bidStrategy);

    return isSimulatorEnabledInConfig && isSimulatorEnabledForBiddingStrategy;
};
